import { createAction } from 'typesafe-actions';
import { OnboardingForm } from './types';

export const FORMS_SET_ONBOARDING = 'FORMS_SET_ONBOARDING';
export const FORMS_SET_QUESTIONS = 'FORMS_SET_QUESTIONS';

export const setOnboardingForm = createAction(FORMS_SET_ONBOARDING)<OnboardingForm>();
export const setQuestionForm = createAction(FORMS_SET_QUESTIONS)<string>();
